import { render, staticRenderFns } from "./IPSSOBOTModal.vue?vue&type=template&id=75196d1c&scoped=true"
import script from "./IPSSOBOTModal.vue?vue&type=script&lang=js"
export * from "./IPSSOBOTModal.vue?vue&type=script&lang=js"
import style0 from "./IPSSOBOTModal.vue?vue&type=style&index=0&id=75196d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75196d1c",
  null
  
)

export default component.exports